module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-search-box",
    class: {
      'vux-search-fixed': _vm.isFixed
    },
    style: ({
      top: _vm.isFixed ? _vm.top : '',
      position: _vm.fixPosition
    })
  }, [_c('div', {
    staticClass: "weui-search-bar",
    class: {
      'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue
    }
  }, [_vm._t("left"), _vm._v(" "), _c('form', {
    staticClass: "weui-search-bar__form",
    attrs: {
      "action": "."
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.$emit('on-submit', _vm.value)
      }
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFixed && _vm.autoFixed),
      expression: "!isFixed && autoFixed"
    }],
    staticClass: "vux-search-mask",
    attrs: {
      "for": ("search_input_" + _vm.uuid)
    },
    on: {
      "click": _vm.touch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-search-bar__box"
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-search-bar__input",
    attrs: {
      "type": "search",
      "autocomplete": "off",
      "id": ("search_input_" + _vm.uuid),
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "compositionstart": function($event) {
        _vm.onComposition($event, 'start')
      },
      "compositionend": function($event) {
        _vm.onComposition($event, 'end')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }, function($event) {
        _vm.onComposition($event, 'input')
      }]
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-icon-clear",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.clear
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFocus && !_vm.value),
      expression: "!isFocus && !value"
    }],
    staticClass: "weui-search-bar__label",
    attrs: {
      "for": ("search_input_" + _vm.uuid)
    }
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]), _vm._v(" "), _c('a', {
    staticClass: "weui-search-bar__cancel-btn",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消') + "\n    ")]), _vm._v(" "), _vm._t("right")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFixed),
      expression: "isFixed"
    }],
    staticClass: "weui-cells vux-search_show"
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.results), function(item) {
    return _c('div', {
      staticClass: "weui-cell weui-cell_access",
      on: {
        "click": function($event) {
          _vm.handleResultClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "weui-cell__bd weui-cell_primary"
    }, [_c('p', [_vm._v(_vm._s(item.title))])])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6757c136", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6757c136"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/search/index.vue
// module id = 272
// module chunks = 18